import { Reducer } from 'interfaces'
import { VideoCallsAppState, ScreenStreamState } from 'components/features/videoCalls/types/state'
import { AgoraScreenShareAction, AgoraStopScreenShareAction, AgoraScreenShareUnavailableAction } from 'components/features/videoCalls/types/actions'

export const screenStreamReducer: Reducer<VideoCallsAppState['screenStream']> = (prevState = new ScreenStreamState(), action) => {
  switch (action.type) {
    case AgoraScreenShareAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          state: 'progress',
        }
      }
      if (action.meta === 'success') {
        const { clientId, localStreamId } = action.payload.response
        return {
          ...prevState,
          state: 'active',
          clientId,
          streamId: localStreamId,
        }
      }

      if (action.payload.unavailable) {
        return {
          ...prevState,
          isAvailable: false,
          state: 'idle',
        }
      }

      return {
        ...prevState,
        state: 'idle',
      }
    }

    case AgoraStopScreenShareAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          state: 'progress',
        }
      }
      if (action.meta === 'success') {
        return {
          ...prevState,
          state: 'idle',
          streamId: null,
          clientId: null,
        }
      }

      return {
        ...prevState,
        state: 'active',
      }
    }

    case AgoraScreenShareUnavailableAction.type: {
      return {
        ...prevState,
        isAvailable: false,
        state: 'idle',
      }
    }
  }
  return prevState
}
